import { defineMessages } from 'react-intl';

/** The price step, the make and its end (design directed-video f1 to f3, g1 to g4, j4, j5). */
export const priceMessages = defineMessages({
  // The price (f1, f2)
  title: { id: 'app.sml.musicVideo.directed.price.title', defaultMessage: 'Check the price' },
  intro: {
    id: 'app.sml.musicVideo.directed.price.intro',
    defaultMessage:
      'The script has {count, plural, one {# new shot} other {# new shots}}. You pay for the new shots only. Check what you get and what you have, then start the video.',
  },
  balanceEyebrow: { id: 'app.sml.musicVideo.directed.price.balanceEyebrow', defaultMessage: 'Your credits' },
  nextEyebrow: { id: 'app.sml.musicVideo.directed.price.nextEyebrow', defaultMessage: 'What happens next' },
  eyebrow: { id: 'app.sml.musicVideo.directed.price.eyebrow', defaultMessage: 'The price of this video' },
  credits: { id: 'app.sml.musicVideo.directed.price.credits', defaultMessage: 'credits' },
  loading: { id: 'app.sml.musicVideo.directed.price.loading', defaultMessage: 'Counting the new shots' },
  director: {
    id: 'app.sml.musicVideo.directed.price.director',
    defaultMessage: 'The director: stories, styles, the script, rewrites',
  },
  castPictures: {
    id: 'app.sml.musicVideo.directed.price.castPictures',
    defaultMessage: 'AI pictures for the cast ({count} made)',
  },
  effects: {
    id: 'app.sml.musicVideo.directed.price.effects',
    defaultMessage: 'Effects, titles, lyric moments ({count})',
  },
  render: {
    id: 'app.sml.musicVideo.directed.price.render',
    defaultMessage: 'The render: the whole song, 1080p, 16:9',
  },
  includedPhone: {
    id: 'app.sml.musicVideo.directed.price.includedPhone',
    defaultMessage: 'Director, cast pictures, effects, render',
  },
  included: { id: 'app.sml.musicVideo.directed.price.included', defaultMessage: 'Included' },
  youHave: { id: 'app.sml.musicVideo.directed.price.youHave', defaultMessage: 'You have' },
  youHaveSplit: {
    id: 'app.sml.musicVideo.directed.price.youHaveSplit',
    defaultMessage: 'You have · {plan} on the {planName} plan, {packs} in a pack',
  },
  youHavePlan: {
    id: 'app.sml.musicVideo.directed.price.youHavePlan',
    defaultMessage: 'You have · {plan} on the {planName} plan',
  },
  amount: { id: 'app.sml.musicVideo.directed.price.amount', defaultMessage: '{count} credits' },
  noLimit: { id: 'app.sml.musicVideo.directed.price.noLimit', defaultMessage: 'No limit' },
  after: { id: 'app.sml.musicVideo.directed.price.after', defaultMessage: 'After this video' },
  missing: { id: 'app.sml.musicVideo.directed.price.missing', defaultMessage: 'Missing' },
  refundRule: {
    id: 'app.sml.musicVideo.directed.price.refundRuleShare',
    defaultMessage:
      'A shot that fails gets two more tries at our cost. If it still fails, another shot of this video fills its place and its share of the price comes back. If more than a quarter of the shots fail, all {total} credits come back.',
  },
  refundRulePhone: {
    id: 'app.sml.musicVideo.directed.price.refundRuleSharePhone',
    defaultMessage:
      'A failed shot is tried again at our cost. If it still fails, its share of the price comes back. More than a quarter failed: all {total} come back.',
  },
  backToScript: { id: 'app.sml.musicVideo.directed.price.backToScript', defaultMessage: 'Back to the script' },
  make: { id: 'app.sml.musicVideo.directed.price.make', defaultMessage: 'Make the video · {total} credits' },
  makeHint: {
    id: 'app.sml.musicVideo.directed.price.makeHint',
    defaultMessage: 'It takes a while for a whole song. You can close this page; the song page shows the progress.',
  },
  addPack: { id: 'app.sml.musicVideo.directed.price.addPack', defaultMessage: 'Add a credit pack' },
  packNotEnough: { id: 'app.sml.musicVideo.directed.price.packNotEnough', defaultMessage: 'Not enough for this video' },
  packEnough: {
    id: 'app.sml.musicVideo.directed.price.packEnough',
    defaultMessage: 'Enough · {left} left after it',
  },
  buyPack: { id: 'app.sml.musicVideo.directed.price.buyPack', defaultMessage: 'Buy {count} credits · {price}' },
  packsHint: {
    id: 'app.sml.musicVideo.directed.price.packsHintLength',
    defaultMessage: 'Packs never run out. Or make the script shorter: fewer and shorter new clips cost less.',
  },
  shortHint: {
    id: 'app.sml.musicVideo.directed.price.shortHint',
    defaultMessage: 'Make the script shorter: fewer and shorter new clips cost less.',
  },
  aiNeedsPlan: {
    id: 'app.sml.musicVideo.directed.price.aiNeedsPlan',
    defaultMessage:
      'The new shots are AI footage. AI footage needs Pro or a bigger plan. The trial and Free do not make it.',
  },
  packsNeedPlan: {
    id: 'app.sml.musicVideo.directed.price.packsNeedPlan',
    defaultMessage: 'Credit packs are for paid plans. A plan gives you more credits each month.',
  },
  seePlans: { id: 'app.sml.musicVideo.directed.price.seePlans', defaultMessage: 'See the plans' },

  // The confirm errors (f3)
  stale: {
    id: 'app.sml.musicVideo.directed.price.stale',
    defaultMessage:
      '<b>The script changed after you saw the price.</b> The new price is {total} credits ({count, plural, one {# new shot} other {# new shots}}). Nothing was charged.',
  },
  seeNewPrice: { id: 'app.sml.musicVideo.directed.price.seeNewPrice', defaultMessage: 'See the new price' },
  otherMaking: {
    id: 'app.sml.musicVideo.directed.price.otherMaking',
    defaultMessage:
      '<b>Another directed video is being made.</b> One at a time per workspace. This one waits here, ready to go.',
  },
  songRendering: {
    id: 'app.sml.musicVideo.directed.price.songRendering',
    defaultMessage:
      '<b>A music video of this song is being made now.</b> Try again when it is done. Nothing was charged.',
  },
  budget: {
    id: 'app.sml.musicVideo.directed.price.budget',
    defaultMessage: '<b>Directed videos are busy now.</b> Try again later. Nothing was charged; your script is saved.',
  },
  noCredits: {
    id: 'app.sml.musicVideo.directed.price.noCredits',
    defaultMessage: '<b>Not enough credits.</b> Nothing was charged; your script is saved.',
  },
  confirmFailed: {
    id: 'app.sml.musicVideo.directed.price.confirmFailed',
    defaultMessage: 'The video did not start. Nothing was charged. Try again.',
  },

  // The make (g1, g2, j5)
  makingTitle: { id: 'app.sml.musicVideo.directed.progress.title', defaultMessage: 'Making your video' },
  makingText: {
    id: 'app.sml.musicVideo.directed.progress.text',
    defaultMessage:
      'Each shot is made for this video only. You can close this page: the song page shows the progress, and we tell you when it is ready.',
  },
  renderingTitle: { id: 'app.sml.musicVideo.directed.progress.renderingTitle', defaultMessage: 'Rendering your video' },
  renderingText: {
    id: 'app.sml.musicVideo.directed.progress.renderingText',
    defaultMessage:
      'All shots are made. Now the cut is put together with the lyrics and the effects, and rendered in 1080p.',
  },
  clipsMade: { id: 'app.sml.musicVideo.directed.progress.clipsMade', defaultMessage: 'of {total} clips made' },
  clipsMaking: {
    id: 'app.sml.musicVideo.directed.progress.clipsMaking',
    defaultMessage: '{count} in the making',
  },
  partsRendered: {
    id: 'app.sml.musicVideo.directed.progress.partsRendered',
    defaultMessage: 'of {total} parts rendered',
  },
  renderStarting: { id: 'app.sml.musicVideo.directed.progress.renderStarting', defaultMessage: 'The render starts' },
  thenRender: {
    id: 'app.sml.musicVideo.directed.progress.thenRender',
    defaultMessage: 'Then the cut is rendered',
  },
  minutesLeft: {
    id: 'app.sml.musicVideo.directed.progress.minutesLeft',
    defaultMessage: 'About {minutes, plural, one {# min} other {# min}} left',
  },
  creditsTaken: { id: 'app.sml.musicVideo.directed.progress.creditsTaken', defaultMessage: '{count} credits taken' },
  creditsTakenBack: {
    id: 'app.sml.musicVideo.directed.progress.creditsTakenBack',
    defaultMessage: '{count} credits taken · {back} back',
  },
  phaseCredits: { id: 'app.sml.musicVideo.directed.progress.phaseCredits', defaultMessage: 'Credits taken' },
  phaseCreditsValue: {
    id: 'app.sml.musicVideo.directed.progress.phaseCreditsValue',
    defaultMessage: '{count} credits',
  },
  phaseShots: { id: 'app.sml.musicVideo.directed.progress.phaseShots', defaultMessage: 'Making the shots' },
  phaseClipsValue: {
    id: 'app.sml.musicVideo.directed.progress.phaseClipsValue',
    defaultMessage: '{done} of {total} clips made',
  },
  phaseShotsDone: {
    id: 'app.sml.musicVideo.directed.progress.phaseShotsDone',
    defaultMessage: '{made} made · {failed} failed',
  },
  phaseCut: { id: 'app.sml.musicVideo.directed.progress.phaseCut', defaultMessage: 'Building the cut' },
  phaseCutValue: { id: 'app.sml.musicVideo.directed.progress.phaseCutValue', defaultMessage: 'shots, lyrics, effects' },
  phaseRender: { id: 'app.sml.musicVideo.directed.progress.phaseRender', defaultMessage: 'Rendering' },
  phaseRenderValue: { id: 'app.sml.musicVideo.directed.progress.phaseRenderValue', defaultMessage: '{length} · 1080p' },
  phaseRenderPart: {
    id: 'app.sml.musicVideo.directed.progress.phaseRenderPart',
    defaultMessage: 'part {part} of {total}',
  },
  tileShot: { id: 'app.sml.musicVideo.directed.progress.tileShot', defaultMessage: 'Shot {number}' },
  tileMakingNote: {
    id: 'app.sml.musicVideo.directed.progress.tileMakingNote',
    defaultMessage: 'Clip {number} is in the making.',
  },
  tileFailed: { id: 'app.sml.musicVideo.directed.progress.tileFailed', defaultMessage: 'failed' },
  tileFailedNote: {
    id: 'app.sml.musicVideo.directed.progress.tileFailedNote',
    defaultMessage: 'Shot {number} could not be made. Another shot of this video fills its place.',
  },
  tilesLabel: { id: 'app.sml.musicVideo.directed.progress.tilesLabel', defaultMessage: 'The shots of the video' },
  failedShots: {
    id: 'app.sml.musicVideo.directed.progress.failedShots',
    defaultMessage:
      '<b>{count, plural, one {# shot} other {# shots}} could not be made</b> (three tries each). Other shots of this video fill their place, and <b>{credits} credits are back</b>. In the editor you can make them again for {cost} credits each.',
  },
  closeHint: {
    id: 'app.sml.musicVideo.directed.progress.closeHint',
    defaultMessage: 'You can close this page. We tell you when the video is ready.',
  },
  backToSong: { id: 'app.sml.musicVideo.directed.progress.backToSong', defaultMessage: 'Back to the song' },

  // Failed (g4)
  failedTitle: { id: 'app.sml.musicVideo.directed.failed.title', defaultMessage: 'We could not make this video' },
  failedClips: {
    id: 'app.sml.musicVideo.directed.failed.clips',
    defaultMessage: 'Too many shots failed ({failed} of {total}). <b>All {credits} credits are back.</b>',
  },
  failedRender: {
    id: 'app.sml.musicVideo.directed.failed.render',
    defaultMessage: 'The render failed. <b>All {credits} credits are back.</b>',
  },
  failedNoCredits: {
    id: 'app.sml.musicVideo.directed.failed.noCredits',
    defaultMessage: 'Something went wrong. <b>All your credits are back.</b>',
  },
  failedFootage: {
    id: 'app.sml.musicVideo.directed.failed.footage',
    defaultMessage:
      'The {count, plural, one {# shot that worked is} other {# shots that worked are}} in Footage → Yours, free to use.',
  },
  startNew: { id: 'app.sml.musicVideo.directed.failed.startNew', defaultMessage: 'Start a new directed video' },
});
